//import { get, post } from './../utils/fetch.js'
import axios from '@/utils/api.request'

// 获取文章列表
export const getNewsList = (data) => {
	data.func = 'getNewsList';
	return axios.request({
		url: '',
		data,
		method: 'post'
	})
}
// 根据id获取文章内容
export const getNewsById = (data) => {
	data.func = 'getNewsById';
	return axios.request({
		url: '',
		data,
		method: 'post'
	})
}


/* 游戏资料页 */
// 名将录
export const getGeneralList = (data) => {
	data.func = 'getGeneralList';
	data.t = 'g';
	return axios.request({
		url: '',
		data,
		method: 'post'
	})
}
// 武将信息
export const getGeneralByName = (data) => {
	data.func = 'getGeneralByName';
	data.t = 'g';
	return axios.request({
		url: '',
		data,
		method: 'post'
	})
}
// 装备
export const getEquipList = (data) => {
	data.func = 'getEquipList';
	data.t = 'g';
	return axios.request({
		url: '',
		data,
		method: 'post'
	})
}
// 兵种
export const getArmyTypeList = (data) => {
	data.func = 'getArmyTypeList';
	data.t = 'g';
	return axios.request({
		url: '',
		data,
		method: 'post'
	})
}
// 组合技能
export const getUnionSkill = (data) => {
	data.func = 'getUnionSkill';
	data.t = 'g';
	return axios.request({
		url: '',
		data,
		method: 'post'
	})
}
// 持续状态
export const getKeepStatus = (data) => {
	data.func = 'getKeepStatus';
	data.t = 'g';
	return axios.request({
		url: '',
		data,
		method: 'post'
	})
}
// 名甲
export const getEquipArmorList = (data) => {
	data.func = 'getEquipArmorList';
	data.t = 'g';
	return axios.request({
		url: '',
		data,
		method: 'post'
	})
}
// 专属武器
export const getEquipVipList = (data) => {
	data.func = 'getEquipVipList';
	data.t = 'g';
	return axios.request({
		url: '',
		data,
		method: 'post'
	})
}



// WEBPACK FOOTER //
// ./src/api/article.js